import { render, staticRenderFns } from "./HistorialPaciente.vue?vue&type=template&id=cf88da74&"
import script from "./HistorialPaciente.vue?vue&type=script&lang=js&"
export * from "./HistorialPaciente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports